import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar, LineClamp } from '../../../global/commonStyle';

const ModalHead = styled.div`
  ${FlexBetween}
  padding: var(--space-11) var(--space-11) var(--space-14);
  ${mobile_xl(css`
    gap: var(--space-20);
  `)}
`;

const DropdownWrapper = styled.div`
  display: flex;
  gap: var(--space-4);
`;

const Headline = styled.h6`
  ${Typography.body_md}
  margin: var(--space-0);
  padding: var(--space-1) var(--space-5);
  text-align: left;
  ${LineClamp(1)}
  word-break: break-all;
  border-radius: var(--border-radius-4);
  color: var(--text-primary);
  &:hover {
    cursor: pointer;
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    line-height: 16px;
  `)}
`;
const ModalHeadLeft = styled.div`
  ${AlignCenter}
  gap: var(--space-2);
  .dot-icon {
    fill: var(--text-placeholder);
  }
`;

const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-10);
  padding-inline: var(--space-16);
  min-height: 129px;
  height: 100%;
  ${mobile_xl(css`
    gap: var(--space-16);
  `)}
`;
const TextField = styled.div`
  width: 100%;
  .taskArea {
    ${Typography.heading_lg}
    color: var(--text-primary);
    margin: var(--space-0);
    border: none;
    background-color: var(--background-primary);
    border-radius: var(--border-radius-4);
    padding: var(--space-0);
    width: 648px;
    max-width: 100%;
    ${HideScrollbar}
    ::placeholder {
      ${Typography.heading_lg}
      color: var(--text-primary);
    }
    &:focus {
      outline: none;
      z-index: var(--z-index-toast);
      border-inline-end-width: 1px;
      outline: 0;
    }
    a {
      color: var(--text-secondary);
      text-decoration: underline;
    }
  }
  ${mobile_xl(css`
    .taskArea {
      width: 100%;
    }
  `)}
`;

const Textarea = styled.div`
  width: 100%;
  position: relative;
  .taskArea {
    ${Typography.body_md}
    color: var(--text-primary);
    border: none;
    background-color: var(--text-white);
    border-radius: var(--border-radius-4);
    padding-block: var(--space-2);
    font-family: unset;
    width: 100%;
    min-width: 648px;
    max-width: 100%;
    ${HideScrollbar}
    ::placeholder {
      ${Typography.body_md}
      color: var(--text-secondary);
    }
    &:focus {
      outline: none;
      z-index: var(--z-index-toast);
      border-inline-end-width: 1px;
      outline: 0;
    }
    a {
      color: var(--text-link);
      text-decoration: underline;
    }
  }
  img {
    max-width: 100%;
  }
  &.task-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const Btns = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: var(--space-24) var(--space-16) var(--space-16);
  gap: var(--space-32);
  ${mobile_xl(css`
    gap: var(--space-12);
    flex-direction: column;
    padding: var(--space-12) var(--space-16) var(--space-16);
  `)}
`;

const ButtonDiv = styled.div`
  width: max-content;
  display: flex;
  gap: var(--space-4);
  ${mobile_xl(css`
    width: 100%;
    justify-content: space-between;
  `)}
  .active {
    background: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
    .svg {
      path {
        fill: var(--text-primary);
      }
    }
  }
`;

const UploadDiv = styled.div`
  padding-inline: var(--space-16);
  color: var(--text-primary);
`;

const Icons = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  flex-wrap: wrap;
  ${mobile_xl(css`
    max-width: 100%;
    width: 100%;
    padding-bottom: var(--space-12);
    box-shadow: var(--bottom-border);
  `)}
`;

const OverLayDiv = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const ModalHeader = styled.div`
  ${AlignCenter}
  gap: var(--space-2);
  position: relative;
  .dot-icon {
    fill: var(--text-placeholder);
  }
`;
const HeadTitle = styled.div`
  ${Typography.body_md}
  padding: var(--space-1)var(--space-5);
  ${LineClamp(1)}
  word-break: break-all;
  border-radius: var(--border-radius-4);
  color: var(--text-primary);
  position: relative;
  &:hover {
    cursor: pointer;
    background: var(--neutral-secondary);
  }
`;

const MenuItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
`;
const TaskTitle = styled.textarea`
  font-family: unset;
  resize: none;
  overflow: hidden;
  min-height: 25px;
  line-height: 1.5;
`;
export {
  Btns,
  Headline,
  Icons,
  ModalHead,
  ModalHeadLeft,
  Textarea,
  TextField,
  Inputs,
  OverLayDiv,
  ModalHeader,
  HeadTitle,
  ButtonDiv,
  UploadDiv,
  MenuItem,
  TaskTitle,
  DropdownWrapper
};
